export const LOCAL_STORAGE = {
	USER: 'userInfo',
	LOG: 'log',
	TOKEN: 'userToken',
};
